import { DeepPartial, NextQueriesConfig } from '@empathybroker/ebx-gluon';

export const MOBILE_NEXT_QUERIES_CONFIG: DeepPartial<NextQueriesConfig> = {
  gridColumns: 2
};

export const DESKTOP_NEXT_QUERIES_CONFIG: DeepPartial<NextQueriesConfig> = {
  gridColumns: 4
};
